import { useMutation, useQueryClient } from 'react-query';
import { NewsApi, NewsFeedItem } from '../../NewsApi';
import { newsFeedQueryKey } from './useNewsFeedQuery';

function markAsReadInCachedFeed(newsItems: NewsFeedItem[], ids: number[]): NewsFeedItem[] {
    return newsItems.map((item) =>
        ids.indexOf(item.id) === -1 ? item : { ...item, isRead: true }
    );
}

export function useMarkNewsAsReadMutation(
    userId: number,
    onError?: (error: unknown) => void,
    saveOnServer = true
) {
    const queryClient = useQueryClient();
    const queryKey = [newsFeedQueryKey, userId];

    const markNewsAsRead = (ids: number[]) =>
        saveOnServer ? NewsApi.markNewsAsRead(ids) : Promise.resolve();

    return useMutation(markNewsAsRead, {
        onMutate: async (ids: number[]) => {
            await queryClient.cancelQueries(queryKey);
            const previousNewsItems = queryClient.getQueryData<NewsFeedItem[]>(queryKey);
            if (previousNewsItems) {
                queryClient.setQueryData(queryKey, markAsReadInCachedFeed(previousNewsItems, ids));
            }
            return { previousNewsItems };
        },
        onError: (
            error: unknown,
            ids: number[],
            context: { previousNewsItems?: NewsFeedItem[] } | undefined
        ) => {
            if (context && context.previousNewsItems) {
                queryClient.setQueryData(queryKey, context.previousNewsItems);
            }
            if (onError) {
                onError(error);
            }
        },
        onSettled: () => {
            if (saveOnServer) {
                queryClient.invalidateQueries(queryKey);
            }
        }
    });
}
